module.exports = __webpack_public_path__ + "static/media/share-work.007c00b7.jpg";